
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        this.breakSelector = this.closest('product-info')?.querySelector('[data-rc-break-multiselect]');
        this.shopifyPaymentButton = this.querySelector('.shopify-payment-button');

        // ROMANIA COLLECTS - GROUP BREAK MULTISELECT
        if (this.breakSelector) {
          this.breakSelector.addEventListener(
            'change',
            this.onBreakSelectionChange.bind(this)
          );

          this.onBreakSelectionChange();
        }

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.breakSelector) {
          const selectedVariants = Array.from(
            this.breakSelector.querySelectorAll('input[type="checkbox"]:checked')
          ).map((input) => input.value);

          if (selectedVariants.length === 0) {
            this.handleErrorMessage('Selectează cel puțin un spot.');
            return;
          }

          if (selectedVariants.length === 1) {
            this.variantIdInput.value = selectedVariants[0];
            this.variantIdInput.disabled = false;
          } else {
            this.addBreakVariants(evt, selectedVariants);
            return;
          }
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            // ROMANIA COLLECTS - RESET BREAK SELECTION AFTER SUCCESS
            if (this.breakSelector) {
              this.breakSelector
                .querySelectorAll('input[type="checkbox"]:checked')
                .forEach((input) => {
                  input.checked = false;
                });

              this.onBreakSelectionChange();
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      onBreakSelectionChange(evt) {
        if (!this.breakSelector) return;

        const selected = Array.from(
          this.breakSelector.querySelectorAll('input[type="checkbox"]:checked')
        );

        const count = selected.length;
        const summary = this.breakSelector.querySelector('[data-rc-break-selection]');
        const totalElement = this.breakSelector.querySelector('[data-rc-break-total]');

        // Păstrăm ordinea în care au fost selectate spoturile.
        this.breakSelectionOrder = this.breakSelectionOrder || [];

        if (evt?.target?.matches('input[type="checkbox"]')) {
          const changedId = evt.target.value;

          this.breakSelectionOrder = this.breakSelectionOrder.filter(
            (id) => id !== changedId
          );

          if (evt.target.checked) {
            this.breakSelectionOrder.push(changedId);
          }
        }

        const selectedIds = selected.map((input) => input.value);

        this.breakSelectionOrder = this.breakSelectionOrder.filter(
          (id) => selectedIds.includes(id)
        );

        const lastSelectedId =
          this.breakSelectionOrder[this.breakSelectionOrder.length - 1];

        const lastSelected = selected.find(
          (input) => input.value === lastSelectedId
        );

        // Actualizăm prețul principal direct, fără solicitări către Shopify.
        const productInfo = this.closest('product-info');
        const priceContainer = productInfo?.querySelector('[id^="price-"]');

        if (priceContainer) {
          const isOnSale = priceContainer.querySelector('.price--on-sale');

          const priceElement = isOnSale
            ? priceContainer.querySelector('.price-item--sale')
            : priceContainer.querySelector('.price-item--regular');

          if (priceElement) {
            priceElement.textContent = lastSelected
              ? lastSelected.dataset.variantPriceDisplay
              : this.breakSelector.dataset.initialPrice;
          }
        }

        if (summary) {
          summary.textContent = `${count} ${
            count === 1 ? 'spot selectat' : 'spoturi selectate'
          }`;
        }

        const total = selected.reduce((sum, input) => {
          return sum + Number(input.dataset.variantPrice || 0);
        }, 0);

        if (totalElement) {
          totalElement.textContent = new Intl.NumberFormat(
            document.documentElement.lang || 'ro-RO',
            {
              style: 'currency',
              currency: window.Shopify?.currency?.active || 'RON',
              minimumFractionDigits: 2
            }
          ).format(total / 100);
        }

        if (count === 1) {
          this.variantIdInput.value = selected[0].value;
          this.variantIdInput.disabled = false;
        } else {
          this.variantIdInput.value = count > 1 ? selected[0].value : '';
          this.variantIdInput.disabled = false;
        }

        if (this.shopifyPaymentButton) {
          this.shopifyPaymentButton.style.display = count === 1 ? '' : 'none';
        }

        this.toggleSubmitButton(count === 0);
        this.submitButton.removeAttribute('aria-disabled');
        this.error = false;
        this.handleErrorMessage();
      }

      addBreakVariants(evt, selectedVariants) {
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';

        const linesUpdateDeferred = this.createBreakCartLinesUpdateEvent(selectedVariants);

        const payload = {
          items: selectedVariants.map((variantId) => ({
            id: Number(variantId),
            quantity: 1,
          })),
        };

        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id).join(',');
          payload.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = JSON.stringify(payload);

        fetch(`${routes.cart_add_url}.js`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              linesUpdateDeferred?.reject(
                new Error(response.description || response.message)
              );

              this.handleErrorMessage(
                response.description || response.message || 'Nu s-au putut adăuga spoturile în coș.'
              );

              this.dispatchCartErrorEvent(
                response.description || response.message,
                'INVALID'
              );

              this.error = true;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            window.location = window.routes.cart_url;
            return;
          })
          .catch((error) => {
            console.error(error);
            linesUpdateDeferred?.reject(error);
            this.handleErrorMessage('A apărut o eroare. Te rugăm să încerci din nou.');

            this.dispatchCartErrorEvent(
              error.message || 'Network error',
              'SERVICE_UNAVAILABLE'
            );

            this.error = true;
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner').classList.add('hidden');

            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      createBreakCartLinesUpdateEvent(selectedVariants) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();

        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: selectedVariants.map((variantId) => ({
              merchandiseId: variantId,
              quantity: 1,
            })),
            promise: deferred.promise,
          })
        );

        return deferred;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();

        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );

        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;

        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) {
              return deferred.reject(new Error('Missing currency in cart response'));
            }

            deferred.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart)
            });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;

        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
